<template>
  <ProcessLogin strategy="microsoft" />
</template>

<script>
import ProcessLogin from "@/components/oauthLogin/ProcessLogin";
import { mapMutations } from "vuex";
export default {
  name: "microsoft",
  components: { ProcessLogin },
  mounted() {
    this.$store.commit("auth/setStrategy", "google");
  },
  methods: {
    ...mapMutations("data", ["setDownload"]),
  },
};
</script>
